import { gql, useQuery } from "@apollo/client"
import { Query } from "@oysterhr/schema"

export const QUERY = gql`
  query EquitySupportedCountries {
    equitySupportedCountries
  }
`
export const useEquitySupportedCountries = () =>
  useQuery<Pick<Query, "equitySupportedCountries">>(QUERY, {
    variables: {},
    fetchPolicy: "no-cache",
  })
